module.exports = __webpack_public_path__ + "img/Alga-LightItalic.4bfa6edd.svg";